angular.module('psModule').controller('ruleModalCtrl',
    function($scope, $uibModalInstance, fbelopp) {
        $scope.fbelopp = fbelopp;

        var removeEventListener = $scope.$on("$locationChangeStart", function() {
            removeEventListener();
            $uibModalInstance.dismiss();
        });
    });
